import { LineupStatusType, ProfileType } from "../types/enum";
import superCalculationHelper from "./superCalculationHelper";
import currencyHelper from "./currency"

class bookingCalculationHelper {
    
    calculatedBookingFee = (booking, currentProfile)  => {
        let agentActOwner = currentProfile?.type === ProfileType.Agent.ordinal && booking.createdById !== currentProfile?.id && booking?.act?.actAdminId === currentProfile?.id;
                let totalFee = 0;
                booking?.lineups?.forEach(l => {
                    if (l.status !== LineupStatusType.Removed.ordinal) {
                        totalFee += parseFloat(l.fee)
                    }                                    
                });  
                var gigFee = booking.isSuperFee ? booking.totalFee : booking.gigFee
                var performanceFee = 0
                if(booking.isPayByActOwner && booking.isSuperFee){
                    performanceFee = parseFloat(booking?.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(booking.actFee,booking.percentageFeeSuper) : booking.actFee).toFixed(2)
                }else{
                    performanceFee = booking.actFee
                    //performanceFee = parseFloat(booking?.includeSuper ? parseFloat(booking.actFee) : parseFloat(booking.actFee) + (parseFloat(booking.percentageFeeSuper) * parseFloat(booking.actFee)/100)).toFixed(2)
                }
                var agentFee = currentProfile?.currencySymbol + currencyHelper.formatMoney(agentActOwner ? parseFloat(booking.actFee) - parseFloat(totalFee) : booking.agentCommissionAmount, 2);

                var agentFeeNumber = agentActOwner ? parseFloat(booking.actFee) - parseFloat(totalFee) : booking.agentCommissionAmount;

                var agentCommissionAmount = booking.createdBy?.type === ProfileType.Agent.ordinal && ((currentProfile?.type === ProfileType.Staff.ordinal && booking.agentOwner?.hideVenueAgencyFees) || (booking.agentOwner?.hideArtistAgencyFees && currentProfile?.type === ProfileType.Musician.ordinal)) ? <i className={"icon-eye-blocked"} /> : `${currentProfile?.currencySymbol}${currencyHelper.formatMoney(booking.agentCommissionAmount, 2)}`
                
                const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal && booking.createdById === currentProfile?.id && !booking.act?.actName;

                let linuep = booking?.lineups?.find(x => x.profileId === currentProfile?.id);

                var totalRosterFee = 0

                booking?.lineups?.forEach(lineUp => {
                    totalRosterFee = parseFloat(totalRosterFee) + parseFloat(lineUp.fee) 
                })
                
                var adminFee = parseFloat(performanceFee)- totalRosterFee
                var calculateFee = linuep?.fee ?  linuep?.fee : 0
                var isLineupSuperFee = linuep?.isSuperFee ? linuep?.isSuperFee : false
                if(currentProfile?.type  === ProfileType.Musician.ordinal){
                    if(booking?.act?.actAdminId === currentProfile?.id){
                        if(booking.isPayByActOwner){
                            calculateFee = booking.actFee
                        }else{
                            calculateFee = parseFloat(calculateFee) + parseFloat(adminFee)
                        }
                    }
                }

                var bookingCreatorFee = booking.isPayByActOwner ? booking.actFee : adminFee
                let myFee = linuep?.fee ? calculateFee: isEntertainerBookings ? booking.gigFee : (booking.isAdmin && !linuep) ? bookingCreatorFee  : booking.actFee;

                var superFee = 0 
                var feePaidToAct = 0
                // if(!booking.isSuperFee){
                //     superFee = 0
                // }
                // else if((booking.createdById === currentProfile?.id || booking.isConsultantBooking) || booking?.act?.actAdminId === currentProfile?.id && booking.isPayByActOwner){
                //     superFee = booking.includeSuper ? superCalculationHelper.calculateSuperWithInclude(booking.actFee, booking.percentageFeeSuper) : superCalculationHelper.calculateSuperWithExclude(booking.actFee, booking.percentageFeeSuper)// parseFloat(parseFloat(booking.percentageFeeSuper)/100*parseFloat(booking.actFee)).toFixed(2)
                //     feePaidToAct = booking.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(booking.actFee, booking.percentageFeeSuper) : booking.actFee
                // }else if(currentProfile?.type === ProfileType.Musician.ordinal){
                //     superFee = superCalculationHelper.calculateSuperWithInclude(calculateFee, booking.percentageFeeSuper)
                //     feePaidToAct = superCalculationHelper.calculateFeeWithoutSuperWithInclude(calculateFee, booking.percentageFeeSuper)
                // }

               if(booking.createdById === currentProfile?.id || booking.isConsultantBooking){
                    if(!booking.isSuperFee){
                        feePaidToAct = booking.actFee
                        superFee = 0 
                    }else{
                        superFee = booking.includeSuper ? superCalculationHelper.calculateSuperWithInclude(booking.actFee, booking.percentageFeeSuper) : superCalculationHelper.calculateSuperWithExclude(booking.actFee, booking.percentageFeeSuper)
                        feePaidToAct = booking.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(booking.actFee, booking.percentageFeeSuper) : booking.actFee
                    }
                }else if(booking?.act?.actAdminId === currentProfile?.id){
                    if(booking.isSuperFee){
                          superFee = booking.includeSuper ? superCalculationHelper.calculateSuperWithInclude(calculateFee, booking.percentageFeeSuper) : superCalculationHelper.calculateSuperWithExclude(calculateFee, booking.percentageFeeSuper)
                        if(booking.isPayByActOwner){
                            feePaidToAct = booking.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(booking.actFee, booking.percentageFeeSuper) : booking.actFee
                            
                        }else{
                            feePaidToAct = booking.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(calculateFee, booking.percentageFeeSuper) : calculateFee
                        }
                    }else{
                        superFee = 0
                        if(booking.isPayByActOwner){
                            feePaidToAct = booking.actFee
                        }else{
                            feePaidToAct = calculateFee
                        }
                        
                    }
                  
                }else if(currentProfile?.type === ProfileType.Musician.ordinal){
                    if(booking.isSuperFee){
                         if(booking.isPayByActOwner){
                            superFee = superCalculationHelper.calculateSuperWithInclude(calculateFee, booking.percentageFeeSuper)
                            feePaidToAct = superCalculationHelper.calculateFeeWithoutSuperWithInclude(calculateFee, booking.percentageFeeSuper)
                        }else{
                            superFee = booking.includeSuper ? superCalculationHelper.calculateSuperWithInclude(calculateFee, booking.percentageFeeSuper) : superCalculationHelper.calculateSuperWithExclude(calculateFee, booking.percentageFeeSuper)
                            feePaidToAct = booking.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(calculateFee, booking.percentageFeeSuper) : calculateFee
                            
                        }

                    }else if(booking?.act?.actAdminId != currentProfile?.id){
                        if(booking.isPayByActOwner){
                            superFee = isLineupSuperFee ? superCalculationHelper.calculateSuperWithInclude(calculateFee, booking.isSuperFee ? booking.percentageFeeSuper : booking.localSuperPercentage) : 0
                            feePaidToAct = isLineupSuperFee  ?  superCalculationHelper.calculateFeeWithoutSuperWithInclude(calculateFee, booking.isSuperFee ? booking.percentageFeeSuper : booking.localSuperPercentage) : calculateFee
                        }else{
                            superFee = isLineupSuperFee  ? booking.includeSuper ? superCalculationHelper.calculateSuperWithInclude(calculateFee, booking.isSuperFee ? booking.percentageFeeSuper : booking.localSuperPercentage) : superCalculationHelper.calculateSuperWithExclude(calculateFee, booking.isSuperFee ? booking.percentageFeeSuper : booking.localSuperPercentage) : 0
                            feePaidToAct = isLineupSuperFee  ? booking.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(calculateFee, booking.isSuperFee ? booking.percentageFeeSuper : booking.localSuperPercentage) : calculateFee : calculateFee
                            
                        }

                    }else{
                        superFee = 0
                        feePaidToAct = calculateFee
                    }
                   
                }
                var superFeeNumber = superFee
                var superFee = currentProfile?.currencySymbol + currencyHelper.formatMoney(superFee, 2)
                
                var feePaidToActNumber = feePaidToAct
                var feePaidToAct = currentProfile?.currencySymbol + currencyHelper.formatMoney(feePaidToAct, 2) 
            return {myFee,agentFee,gigFee, feePaidToAct, superFee, agentCommissionAmount, performanceFee, agentFeeNumber, superFeeNumber, feePaidToActNumber}
    }

}

export default new bookingCalculationHelper();